import { render, staticRenderFns } from "./CountDown.vue?vue&type=template&id=70414708&scoped=true&"
import script from "./CountDown.vue?vue&type=script&lang=js&"
export * from "./CountDown.vue?vue&type=script&lang=js&"
import style0 from "./CountDown.vue?vue&type=style&index=0&id=70414708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70414708",
  null
  
)

component.options.__file = "CountDown.vue"
export default component.exports